import { render, staticRenderFns } from "./content-field.component.vue?vue&type=template&id=5119f7dc&scoped=true&"
import script from "./content-field.component.ts?vue&type=script&lang=ts&"
export * from "./content-field.component.ts?vue&type=script&lang=ts&"
import style0 from "./content-field.component.scss?vue&type=style&index=0&id=5119f7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119f7dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
